import React from 'react';

import { FaBoxes } from 'react-icons/fa';
import { GiPencilBrush, GiRocket } from 'react-icons/gi';
import { IoIosCloudUpload, IoIosInfinite, IoMdShare } from 'react-icons/io';
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import { AppRoutes, getRoute } from '../../AppRoutes';
import polyglot from '../../Translator';
import './Pricing.scss';
import {
	AngleBackgroundTop,
	FeatureItem,
	Features,
	HeaderTextWrapper,
	PageHeader,
	PriceSection,
	PriceTag,
	PricingFeaturesGrid,
	StartSection,
	StyledLink
} from './PricingStyledComponents';
import pricingTranslations from './PricingTranslations';

// const translations = {
// 	pricingHelmet: {
// 		en: 'Redox | Pricing',
// 		fr: 'Redox | Tarifs'
// 	},
// 	pricingDescriptionHelmet: {
// 		en: 'Redox features simple and transparent pricing.',
// 		fr: 'Redox propose des tarifs simples et transparents.'
// 	},
// 	pricingKeywords: {
// 		en: 'Redox pricing,Automation tool for lawyers pricing,Redox,pricing',
// 		fr: 'Redox tarifs,Redox tarif,Redox,Tarifs,pricing,'
// 	}
// };

export default function Pricing() {
	return (
		<div id="pricing">
			{/* <Helmet>
        <title>{polyglot.tr(translations.pricingHelmet)}</title>
        <meta name="description" content={polyglot.tr(translations.pricingDescriptionHelmet)} />
        <meta name="keywords" content={polyglot.tr(translations.pricingKeywords)} />
      </Helmet> */}

			<PageHeader>
				<AngleBackgroundTop />
				<HeaderTextWrapper>
					<p style={{ textTransform: 'uppercase', fontSize: '20px', fontWeight: 700 }}>
						{polyglot.tr(pricingTranslations.pricingPlan)}
					</p>
					<p style={{ fontSize: '50px', fontWeight: 500 }}>{polyglot.tr(pricingTranslations.clearSimple)}</p>
				</HeaderTextWrapper>
			</PageHeader>

			<Bounce top>
				<PriceSection>
					<PriceTag>
						<span
							style={{
								fontSize: '44px',
								verticalAlign: 'text-top'
							}}
						>
							$
						</span>
						39.
						<span
							style={{
								fontSize: '22px',
								verticalAlign: 'super'
							}}
						>
							99
						</span>
					</PriceTag>

					<p
						style={{
							fontSize: '18px',
							fontWeight: 600
						}}
					>
						{polyglot.tr(pricingTranslations.perUserPerMonth)}
					</p>
				</PriceSection>
			</Bounce>
			<Fade bottom>
				<Features>
					<PricingFeaturesGrid>
						<FeatureItem
							style={{ gridArea: 'box1' }}
							featureIcon={IoIosInfinite}
							featureText={polyglot.tr(pricingTranslations.unlimitedDiagrams)}
						/>

						<FeatureItem
							style={{ gridArea: 'box2' }}
							featureIcon={IoMdShare}
							featureText={polyglot.tr(pricingTranslations.sharedDiagrams)}
						/>
						<FeatureItem
							style={{ gridArea: 'box3' }}
							featureIcon={GiPencilBrush}
							featureText={polyglot.tr(pricingTranslations.customStyling)}
						/>

						<FeatureItem
							style={{ gridArea: 'box4' }}
							featureIcon={FaBoxes}
							featureText={polyglot.tr(pricingTranslations.unlimitedEntities)}
						/>
						<FeatureItem
							style={{ gridArea: 'box5' }}
							featureIcon={IoIosCloudUpload}
							featureText={polyglot.tr(pricingTranslations.backedUp)}
						/>
						<FeatureItem
							style={{ gridArea: 'box6' }}
							featureIcon={GiRocket}
							featureText={polyglot.tr(pricingTranslations.fastWorkflow)}
						/>
					</PricingFeaturesGrid>
				</Features>
			</Fade>
			<StartSection>
				<Slide right>
					<p style={{ marginTop: '100px', fontSize: '36px', fontWeight: 600 }}>
						{polyglot.tr(pricingTranslations.readyStart)}
					</p>
				</Slide>

				<Slide left>
					<StyledLink to={getRoute(AppRoutes.SIGNUP)}>{polyglot.t('créerCompte')}</StyledLink>
				</Slide>
			</StartSection>
		</div>
	);
}
